import { useFormik } from "formik";
import { Grid } from "@mui/material";
import SelectInputBox from "../../../../../../constants/SelectInputBox";
import { ParticularOptions } from "../../../../../../constants/Options";
import { handleSelectBox } from "../../../../../../helpers/handleChange";
import InputTextBox from "../../../../../../constants/InputTextBox";
import { Fragment } from "react/jsx-runtime";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { BILLING_PARTICULAR_LIST_DELETE, BILLING_PARTICULAR_LIST_VIEW } from "../../../../../../store/accountSlice";
import { MdDelete } from "react-icons/md";
import { BillingParticularProps } from "../../../../../../helpers/models/Models";

interface ParticularFormViewProps {
    data: any;
};

const ParticularFormView: React.FC<ParticularFormViewProps> = ({ data }) => {
    const particularOptions = ParticularOptions(data?.particular);
    const initialValues = {
        particular_id: "",
        amount: "",
    };

    const dispatch = useDispatch();
    const [isFetching, setIsFetching] = useState(false);
    const REQUEST_TIMEOUT = 100;

    const billingParticularList = useSelector(
        (state: any) => state.accounts.BillingParticularList
    ); 

    const { values, errors, touched, setFieldValue, handleBlur, resetForm, handleChange, handleSubmit } = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: (values, actions) => {
        },
    });
 
    // Handle key press event
    const handleKeyPress = async (event: any) => {
        if (event.key === "Enter" && !isFetching) {
            setIsFetching(true);
            setTimeout(() => {
                setIsFetching(false);
            }, REQUEST_TIMEOUT);
            const newParticular: BillingParticularProps = {
                particular_id: parseInt(values.particular_id),
                particular_name: particularOptions.find(
                    (option) => option.value === values.particular_id
                )?.label || null, // Ensure this matches the type in the interface
                amount: parseFloat(values.amount), // Convert amount to string if required by your type
            };
            // Dispatch an array containing newParticular
            dispatch(BILLING_PARTICULAR_LIST_VIEW([newParticular]));
            resetForm();
        }
    };
    const handleDelete = (particular_id: number) => {
        dispatch(BILLING_PARTICULAR_LIST_DELETE(particular_id));
    };
    return (
        <Fragment>
            <form onSubmit={handleSubmit} className="mt-10">
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SelectInputBox
                            options={particularOptions}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({
                                    setFieldValue,
                                    name,
                                    value: selectedOption,
                                });
                            }}
                            value={values.particular_id}
                            required={false}
                            placeholder="Select Particular"
                            name="particular_id"
                            handleBlur={() =>
                                handleBlur({ target: { name: "particular_id" } })
                            }
                            touched={touched.particular_id}
                            errors={errors.particular_id}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type="number"
                            name="amount"
                            handleChange={handleChange}
                            value={values.amount}
                            error={errors.amount}
                            handleBlur={handleBlur}
                            touched={touched.amount}
                            onKeyPress={handleKeyPress}
                            required={true}
                            placeholder="Enter Amount"
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <div className="mt-3 rounded-md overflow-x-auto h-36">
                            <table
                                width="100%"
                                className="text-sm text-left rtl:text-right whitespace-nowrap overflow-x-scroll text-gray-500 dark:text-gray-400 rounded"
                            >
                                <thead className="text-[12px] text-gray-500 border-b-2 border-slate-100 dark:border-sky-800 capitalize bg-slate-200 dark:bg-sky-900 dark:text-gray-400">
                                    <tr>
                                        <th scope="col" className="px-2 py-1">
                                            Particulars
                                        </th>
                                        <th scope="col" className="px-2 py-1">
                                            Amount
                                        </th>
                                        <th scope="col" className="px-2 py-1 w-10">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="text-slate-800">
                                    {Array.isArray(billingParticularList) &&
                                        billingParticularList?.map((ledger, index) => (
                                            <tr
                                                key={index}
                                                className="odd:bg-white text-[12px] text-gray-700 dark:text-gray-400 odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b font-public-sans dark:border-gray-700"
                                            >
                                                <td className="px-6 py-1">
                                                    {ledger.particular_name || "N/A"}
                                                </td>
                                                <td className="px-6 py-1">
                                                    {ledger.amount}
                                                </td>
                                                <td className="px-6 py-1">
                                                    <MdDelete
                                                        onClick={() =>
                                                            handleDelete(ledger.particular_id)
                                                        }
                                                        title="Delete"
                                                        className="text-customPrimary cursor-pointer text-[15px] hover:text-gray-800"
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </Grid>
                </Grid>
            </form>
        </Fragment>
    );
};

export default ParticularFormView;
